import React from 'react'
import style from './Delivery.module.scss'
import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale'

const Delivery = () => {
  const { t } = useSurveyLocale()
  return (
    <div className={style.delivery}>
      <div className={style.deliveryIcon}></div>
      <p>
        {t('questions', 'ec', 'amazon', 'deliverTo')} {t('questions', 'ec', 'amazon', 'myAddress')}
      </p>
    </div>
  )
}

export default Delivery
